export default __webpack_public_path__ + "static/media/avatar_pyper1.c06a7e8d.mp3";